export default __webpack_public_path__ + "static/media/turbo_order_sound.d16b7602.mp3";